type Props = {
  value: string;
  onChange: (value: string) => void;
  id?: string;
};

/** Hidden field for bots. Leave empty. Server rejects filled values silently. */
export function HoneypotWebsiteField({ value, onChange, id = "companyWebsite" }: Props) {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-[10000px] h-0 w-0 overflow-hidden opacity-0"
    >
      <label htmlFor={id}>Website</label>
      <input
        id={id}
        name="companyWebsite"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}
